import { compose, join, split, map, toUpper, toLower, isEmpty } from 'ramda';
export var decapitalize = function (str) {
    return isEmpty(str) || typeof str !== 'string'
        ? ''
        : str[0].toLowerCase() + str.slice(1);
};
export var capitalize = function (str) {
    return isEmpty(str) || typeof str !== 'string'
        ? ''
        : toUpper(str[0]) + toLower(str.slice(1));
};
export var capitalizeName = compose(join(' '), map(capitalize), split(' '));
export var unSnake = function (string) { return capitalize(string.split('_').join(' ')); };
export var unSnakeAndCapitalize = function (string) {
    return string ? capitalizeName(unSnake(string)) : '';
};
export var arrayToReadableString = function (array) {
    return array.map(function (item, index) {
        var result = unSnake(item);
        return index > 0 ? ", ".concat(result) : result;
    });
};
export var parseNonZeroJson = function (value) {
    if (!value || value === '0' || value === 0)
        return undefined;
    try {
        return JSON.parse(String(value));
    }
    catch (_a) {
        return undefined;
    }
};
